export default "__VITE_ASSET__BYxvv1Jq__"